export const SET_KEY = "SET_KEY";
export const SET_SORT = "SET_SORT";
export const SET_DATA = "SET_DATA";
export const SET_LOADING = "SET_LOADING";
